import React from "react";
import imgUrl from "../assets/images/imgUrl";
import Typography from "@mui/material/Typography";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";


const CustomPrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <span>{"<"}</span>
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <span>{">"}</span>
  </div>
);

const imgUrls = [
  imgUrl.galleryImgone,
  imgUrl.galleryImgtwo,
  imgUrl.galleryImgthree,
  imgUrl.galleryImgfour,
  imgUrl.galleryImgfive,
  imgUrl.galleryImgsix,
  imgUrl.galleryImgseven,
  imgUrl.galleryImgeight,
  imgUrl.galleryImgnine,
  imgUrl.galleryImgten,
  imgUrl.galleryImgeleven,
  imgUrl.galleryImgtwelve,
  imgUrl.galleryImgthirteen,
  imgUrl.galleryImgfourteen,
  imgUrl.galleryImgfifteen,
  imgUrl.galleryImgsixteen,
  imgUrl.galleryImgseventeen,
  imgUrl.galleryImgeighteen,
  imgUrl.galleryImgnineteen,
  imgUrl.galleryImgtwenty,
  imgUrl.galleryImgtwentyone,
  imgUrl.galleryImgtwentytwo,
  imgUrl.galleryImgtwentythree,
  imgUrl.galleryImgtwentyfour,
  imgUrl.galleryImgtwentyfive,
  imgUrl.galleryImgtwentysix,
  imgUrl.galleryImgtwentyseven,
  imgUrl.galleryImgtwentyeight,
];


const captions = [
"Dr. Bhagwat Karad, Union Minister of State for Finance (16-April-2022)",
"Former Maharashtra Governor, Shri Bhagat Singh Koshyari (06-April-2022)",
"Madhusudan Agrawal, Co-Founder & Vice Chairman, Ajanta Pharma (April-2022)",
"Adil Allana (left), Owner, Allanasons (August-2022)",
"Jackbastian Nazareth (left), CEO, Adani Realty (August-2022)",
"Mr. Fareed Zakaria (left), CNN Journalist (December-2022)",
"Padma Shri Madhu Pandit Dasa (left), Founder Chairman Akshay Patra Foundation (December-2022)",
"Shri Suresh Khade (right), Labour Minister, Maharashtra (06-April-2023)",
"Capt B K Tyagi (right), Chairman & Managing Director, Shipping Corporation of India (May-2023)",
"Dr. Suresh Chandra Padhye (left), Vice Chancellor, Poornima University @ Jaipur (23-September-2023)",
"Yaqoob Al Ali (left), ED & Private Advisor to the Office of His Highness Sheikh Juma bin Maktoum Al Maktoum (September-2024)",
"Anu Malik, Music Composer, 11 Feb 2022",
"Ashish Shelar, ex-Education Minister, Maharashtra 7 Feb 2022",
"Asif Bhamla,Close Friend Chairman Bhamla Foundation @ his 20th wedding anniversary 11 Feb 2022",
"Baba Ramdev, Indian Yoga Guru & Ayurvedic Champion 9 Feb 2022",
"Dr Ramdas Bandu Athawale, Minister of State for Social Justice & Empowerment 13-Feb-2022",
"Dr. Varun Choudhury Close Friend & Director, CG Corp Global 7 Feb 2022",
"Late Raju Srivastav, Comedian, 11 Feb 2022",
"Majeed Menon, Rajya Sabha MP, & Advocate of Supreme Court of India, 11 Feb 2022",
"Mohit Kamboj, BJP Leader 7 Feb 2022",
"Nitin Raut, Minister of Energy, Maharashtra Government 17 Feb 2022",
"Paramjit Dahia, Deputy Commisioner of Police, Worli 12 Feb 2022",
"Poonam Mahajan, Lok Sabha MP 11 Feb 2022",
"Rakeysh Omprakash Mehra, Indian Film Director 20 Feb 2022",
"Richard Prattle, Co-Founder & CEO, True Beacon 24 Feb 2022",
"Shahida Parveen ACP (killed 80 terrorists) 11 Feb 2022",
"Shashi Kumar Meena, Deputy Commisioner of Police 12 Feb 2022",
"Zayed Khan, Close Friend, & Actor 28 Feb 2022"
]

const settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000, 
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};


const videoSettings = {
  dots: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000, 
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

function MediaGallery() {
  return (
    <div className="homeMainWrapper biographyWrapper awardsWrapper thoughtLeadershipwrapper mediaWrapper">
      <div className="homeBackground">
        <div className="upperImage">
          <img src={imgUrl.smileLogo} alt="smile logo"></img>
        </div>
      </div>

      {/* photo and media gallery */}
      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.gallery} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles lifeStorytitle">
            Photo & Media Gallery
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            A picture is worth a thousand words and our Media Gallery offers a visual
            journey through <b> Dr. Huzaifa Khorakiwala’s </b> endeavours:
          </Typography>
        </div>
      </section>

      {/* photo gallery section */}
      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.galleryCarousel} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            Photo Gallery
          </Typography>

          <div
            className="carouselWrapper photoGallerysection mt-30px"
            style={{ width: "100%", maxWidth: "80%", position: "relative" }}
          >
            <Slider {...settings}> 

              {
                imgUrls && imgUrls.map((img, index) => {
                  return <>
                    <div key={index}>
                      <div className="gallery-box">
                        <img src={img} alt={`gallery-${index}`} />
                      </div>
                        <p className="caption">{captions[index]}</p>
                    </div>
                  </>
                })
              }
           
            </Slider>
          </div>
        </div>
      </section>

      {/* video gallery section */}
      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.video} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles lifeStorytitle">
            Video Gallery
          </Typography>

          <div
            className="carouselWrapper mt-30px"
            style={{ width: "100%", maxWidth: "80%", position: "relative" }}
          >
            <Slider {...videoSettings}>
              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="853"
                    height="480"
                    src="https://www.youtube.com/embed/AdDHerbXbxY"
                    title="Dr. Huzaifa Khorakiwala, CEO, Wockhardt Foundation at #GoodAirSummit"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/bouOG7AIDac?si=bjS3N95RKYM8cF4b"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/hx6vNZoIW8U?si=MtfpLqdmVSDz6pUO"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/w35Z7NwAKLA?si=Mc8SiCr49O_ZALeY"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/eMBMd3zMH3o?si=gJNV3VCx08LbzNdt"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/TjEC0ski8SY?si=z_ksDmArWPBWbcle"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/jQFDFyvoEpM?si=Stnu18AyoV2FFVAa"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/Pjf6EXNx9yQ?si=x8cch4gaMl5_r5k-"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/Z2_-fkNKZcE?si=JrFWmvXV-GAWahgd"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/k84oh1aUe0c?si=aHyBudpXgzCmeQ04"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/iBTd4VZngqM?si=J_6hfUc9_Wm7x9vW"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div>
                <div className="gallery-box videoSection">
                  <iframe
                    width="560"
                    height="315"
                    loading="lazy"
                    src="https://www.youtube.com/embed/CqxxZRdW8kg?si=NEfcq_pcVjUus_Oi"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/3RqWqshRqvs"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/QojwgE0aIHI"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/i3V3KPsRGMQ"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/Aya0Qrx8CxA"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/C8gBFZzS8t4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/oBVtroco6fI"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/x-fR6B3QHO4"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/BEAvYgPUw54"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/oj2J-jciWgM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/pPkn306O7JM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/JL8to3T0_qE"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/N-Ga-pG74zM"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/jvTXaff7C-I"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/DB4hVaAFZ6g"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/WbWmMLkphJw"
                  title="YouTube Shorts"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/RvVMCRxtShY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/hdYD2DbPdbo"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/VCfon1wpqtg"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/Lu0dPVkX2h0"
                  title="YouTube Shorts"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/Z1tVZ_p8XvU"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/QAsy2r-mfB0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/XNEHd-1cBx0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/5Wjv8nH_nJw"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/BA3vcOimraE"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="gallery-box videoSection">
                <iframe
                  width="560"
                  height="315"
                  loading="lazy"
                  src="https://www.youtube.com/embed/SnNCdfBOSsk"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      {/* media kit section */}
      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.mediakit} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">Media Kit</Typography>

          <Grid container spacing={3} className="mediaGrids">
            <Grid
              size={{ xs: 12, sm: 6, md: 6, lg: 3 }}
              className=" d-flex-align-center-justify-center flex-direction-column position-relative kitGrids"
            >
              <div className="iconBackground iconRedbg">
                <img
                  src={imgUrl.biography}
                  alt="icon"
                  className="firstImage"
                ></img>
              </div>
              <Card className="mediaCard align-items-start">
                <CardContent className="d-flex-align-center-justify-center flex-direction-column mediaCardcontent firstCard">
                  <Typography className="mediaCardtitle kitTitleone">
                    Official Biography:
                  </Typography>

                  <Typography className="mediaPara mt-10px">
                    A written bio of <b> Dr. Huzaifa Khorakiwala  </b>(in PDF format), covering his
                    background, roles and achievements, suitable for event brochures or
                    articles.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6, lg: 3 }}
              className=" d-flex-align-center-justify-center flex-direction-column position-relative kitGrids"
            >
              <div className="iconBackground iconRedbg">
                <img
                  src={imgUrl.document}
                  alt="icon"
                  className="firstImage"
                ></img>
              </div>
              <Card className="mediaCard align-items-start">
                <CardContent className="d-flex-align-center-justify-center flex-direction-column mediaCardcontent firstCard">
                  <Typography className="mediaCardtitle">
                    Fact Sheet:
                  </Typography>

                  <Typography className="mediaPara mt-10px">
                    A summary of key facts and figures, number of awards, key positions and
                    contact information for his office. This serves as a quick reference for
                    accurate information.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6, lg: 3 }}
              className=" d-flex-align-center-justify-center flex-direction-column position-relative kitGrids secondLinekit"
            >
              <div className="iconBackground iconRedbg">
                <img src={imgUrl.hd} alt="icon"></img>
              </div>
              <Card className="mediaCard">
                <CardContent className="d-flex-align-center-justify-center flex-direction-column mediaCardcontent">
                  <Typography className="mediaCardtitle kitTitleone thirdKittext">
                    High-Resolution Images
                  </Typography>

                  <Typography className="mediaPara mt-10px">
                    A set of approved photographs – including headshots, at-work photos and
                    logo images of associated organisations (<b> Wockhardt Foundation, I Am
                    Peacekeeper, GJLPS </b> etc) – in print-ready resolution.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6, lg: 3 }}
              className=" d-flex-align-center-justify-center flex-direction-column position-relative kitGrids secondLinekit"
            >
              <div className="iconBackground iconRedbg">
                <img src={imgUrl.profile} alt="icon"></img>
              </div>
              <Card className="mediaCard align-items-start">
                <CardContent className="d-flex-align-center-justify-center flex-direction-column mediaCardcontent fourthCard">
                  <Typography className="mediaCardtitle">
                    Media Contact Details
                  </Typography>

                  <Typography className="mediaPara mt-10px">
                    Whom to contact for interviews, statements or event invitations (also listed
                    in the Contact section of this site). Typically, this lists his official
                    representatives with phone numbers and email addresses
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-40px">
            The <b> Media Kit </b> is kept up-to-date. Users can click the <span className="font-italic"> Download Media Kit  </span>
            button to save a ZIP file containing all these resources.
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-10px">
            Whether you are a researcher, journalist or simply an interested individual,
            the <b> Thought Leadership </b> section offers a rich repository to understand and
            engage with the ideas that drive <b> Dr. Khorakiwala’s </b> work. Dive in to be
            inspired and informed by the voice of a true humanitarian leader.
          </Typography>
        </div>
      </section>
    </div>
  );
}

export default MediaGallery;
